'use strict';

namespace Core {

    class ModalParkingDetails {

        Details:any;
        airport:string;
        dropOffDate:string;
        pickUpDate:string;

        constructor(private $scope: ng.IScope, private modalService:any){

            this.Details = modalService.get('details');
            this.airport = modalService.get('airport');
            this.dropOffDate = modalService.get('dropOffDate');
            this.pickUpDate = modalService.get('pickUpDate');
        }
    }

    angular
        .module('core')
        .directive('parkingDetails', (): ng.IDirective => {

        return {
            scope: {},
            controller: ModalParkingDetails,
            controllerAs: 'pd',
            templateUrl: (elem, attr) => {
                return `partials/booking/template?name=ParkingDetails&version=${attr.templateVersion}`;
            }
        };
    });

}
